<template>
    <div class="fleet-solutions">
        <header>
            <img loading="lazy" src="../../assets/fleet-solutions.webp" alt="banner img" />
        </header>

        <div class="container">
                <h1>fleet solutions</h1>
                <p>If you are interested in buying a fleet of cars for your business, please fill out this form with your contact details and preferences. We will get back to you as soon as possible with a quote and a customized offer. Thank you for choosing our dealership.</p>

                <div class="block">
                    <div v-if="theRes.length != 0" style="width: 100%;
                            border-radius: 10px;
                            padding: 1.2em;
                            text-transform: capitalize;
                            background: var(--noble-gold2);
                            border: 2px solid var(--noble-gold);
                            color: var(--tech-black);
                            display: flex;
                            align-items: center;
                            justify-content: space-between;">
                        {{ theRes}}

                        <button style="color: var(--tech-black);" @click="theRes=''">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <div class="form">
                        <!-- name -->
                        <div>
                            <label class="title">Name</label>
                            <input v-model="name" type="text" placeholder="Name">
                            <span class="errorTxt" v-if="errors.name.length>1">{{ errors.name }}</span>
                        </div>

                        <!-- email -->
                        <div>
                            <label class="title">Email</label>
                            <input v-model="email" type="email" placeholder="example@xyz.com">
                            <span class="errorTxt" v-if="errors.email.length>1">{{ errors.email }}</span>
                        </div>

                        <!-- phone -->
                        <div>
                            <label class="title">Phone</label>
                            <input v-model="phone" type="text" placeholder="+218-9x-xxxxxx">
                            <span class="errorTxt" v-if="errors.phone.length>1">{{ errors.phone }}</span>
                        </div>
                    </div>

                    <div class="form">
                        <!-- subject -->
                        <div>
                            <label class="title">Subject</label>
                            <input v-model="subject" type="text" placeholder="Subject text">
                            <span class="errorTxt" v-if="errors.subject.length>1">{{ errors.subject }}</span>
                        </div>
                    </div>

                    <div class="form">
                        <!-- msg  -->
                        <div style="width: 100%;">
                            <textarea v-model="message" placeholder="Send us a message"></textarea>
                            <span class="errorTxt" v-if="errors.message.length>1">{{ errors.message }}</span>
                        </div>
                    </div>

                    
                </div>

                <div class="cta">
                    <div class="g-recaptcha" 
                    data-callback="onCaptchaVerified"
                    data-expired-callback="onCaptchaExpired"
                    data-sitekey="6LezQ64nAAAAABJ_1jDbMwjTWn07462potaAZN16"></div>

                    <button class="square" @click="sendFleetSolution()">submit</button>
                </div>
                <span style="color: red;" class="errorTxt" v-if="errors.captcha.length>1">{{ errors.captcha }}</span>
            </div>

    </div>
</template>

<script>
/* global grecaptcha */
import api from '@/apis';

    export default {
        data() {
            return {
                captchaToken: "", // store token here
                recaptchaWidgetId: null,
                name: "",
                email: "",
                subject: "",
                phone: "",
                message: "",
                errors: {
                    name: "",
                    email: "",
                    phone: "",
                    subject: "",
                    message: "",
                    captcha: ""
                },

                theRes: ""
            }
        },
        methods: {
            validateForm() {
                // Reset errors first
                this.errors.name = "";
                this.errors.phone = "";
                this.errors.email = "";
                this.errors.subject = "";
                this.errors.message = "";

                let isValid = true;

                // ---------- NAME ----------
                if (!this.name.trim()) {
                    this.errors.name = "Name is required";
                    isValid = false;
                } else if (this.name.length < 3) {
                    this.errors.name = "Name must be at least 3 characters";
                    isValid = false;
                } else if (this.name.length > 255) {
                    this.errors.name = "Name cannot exceed 255 characters";
                    isValid = false;
                }

                // ---------- PHONE ----------
                const phoneRegex = /^[0-9]{9,15}$/;
                const phoneClean = this.phone.replace(/^\+/, "");

                if (!phoneClean.trim()) {
                    this.errors.phone = "Phone is required";
                    isValid = false;
                } else if (!phoneRegex.test(phoneClean)) {
                    this.errors.phone = "Phone must contain 9–15 digits only";
                    isValid = false;
                }

                // ---------- EMAIL ----------
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                if (!this.email.trim()) {
                    this.errors.email = "Email is required";
                    isValid = false;
                } else if (this.email.length < 6) {
                    this.errors.email = "Email must be at least 6 characters";
                    isValid = false;
                } else if (this.email.length > 255) {
                    this.errors.email = "Email cannot exceed 255 characters";
                    isValid = false;
                } else if (!emailRegex.test(this.email)) {
                    this.errors.email = "Invalid email format";
                    isValid = false;
                }

                // ---------- SUBJECT ----------
                if (!this.subject.trim()) {
                    this.errors.subject = "Subject is required";
                    isValid = false;
                } else if (this.subject.length < 3) {
                    this.errors.subject = "Subject must be at least 3 characters";
                    isValid = false;
                } else if (this.subject.length > 255) {
                    this.errors.subject = "Subject cannot exceed 255 characters";
                    isValid = false;
                }

                // ---------- MESSAGE ----------
                if (!this.message.trim()) {
                    this.errors.message = "Message is required";
                    isValid = false;
                } else if (this.message.length < 10) {
                    this.errors.message = "Message must be at least 10 characters";
                    isValid = false;
                } else if (this.message.length > 50000) {
                    this.errors.message = "Message cannot exceed 50000 characters";
                    isValid = false;
                }

                return isValid;
            },
            sendFleetSolution() {
                this.errors.captcha = "";

                if (!this.validateForm()) {return;}
                if (!this.captchaToken) {
                    this.errors.captcha = "Please complete the captcha.";
                    return;
                }
                
                api.post("/fleet_solutions?locale=en", {
                    name: this.name,
                    phone: this.phone.replace(/^\+/, ""),
                    email: this.email,
                    subject: this.subject,
                    message: this.message,
                    'g-recaptcha-response': this.captchaToken // <-- this is critical
                })
                .then(res => {
                    // reset inputs 
                    this.theRes = res.data.message;
                    this.name = "";
                    this.phone = "";
                    this.email = "";
                    this.subject = "";
                    this.message = "";
                    // ✅ Safely reset reCAPTCHA — only if available
                    if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
                        // For auto-rendered reCAPTCHA with single widget, reset with no ID
                        grecaptcha.reset();
                        this.captchaToken = null;
                    }
                })
                .catch(error => {
                    // console.log(error);
                    // ✅ Safely reset reCAPTCHA — only if available
                    if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
                        // For auto-rendered reCAPTCHA with single widget, reset with no ID
                        grecaptcha.reset();
                        this.captchaToken = null;
                    }

                    // GLOBAL GUARD
                    if (!error.response ||
                        error.response.status !== 422 ||
                        !error.response.data ||
                        !error.response.data.errors) {
                        // not a validation error → ignore field mapping
                        return;
                    }

                    const backendErrors = error.response.data.errors;

                    // reset errors
                    this.errors.name = "";
                    this.errors.email = "";
                    this.errors.phone = "";
                    this.errors.subject = "";
                    this.errors.message = "";

                    // map backend errors safely
                    Object.keys(this.errors).forEach(field => {
                        if (backendErrors[field]) {
                        this.errors[field] = backendErrors[field][0];
                        }
                    });
                });
            }
        },
        mounted() {
            // reCAPTCHA calls these global functions
            window.onCaptchaVerified = (token) => {
                this.captchaToken = token;
                console.log("✅ CAPTCHA verified:", token);
            };

            window.onCaptchaExpired = () => {
                this.captchaToken = null;
                // console.log("⚠️ CAPTCHA expired");
            };
        },
        beforeDestroy() {
            // Clean up to avoid memory leaks
            delete window.onCaptchaVerified;
            delete window.onCaptchaExpired;
        },
    }
</script>